<template>
	<div
		ref="screenshot"
		class="flow-screenshot"
		:empty="state === -1"
		:inprogress="state === 0"
		:done="state === 1"
		:tabindex="tabindex"
		@click="handleClick($event)"
	>
		<Icon
			v-if="state === -1"
			name="i-camera-1"
			type="filled"
			size="medium"
			state="dark"
			:effects="false"
		/>

		<Icon
			v-if="state === 0"
			name="i-loader"
			state="default"
			:animate="true"
			type="filled"
			:effects="false"
		/>
		<p v-if="state !== 1 && status" class="paragraph-1 fc-dark fw-300">
			{{ status }}
		</p>
		<img v-if="state === 1" :src="src" />
		<Button
			v-if="state === 1"
			state="icon"
			size="small"
			type="error"
			class="remove-screenshot"
			@click.stop="state = -1"
		>
			<Icon name="i-close" type="filled" size="x-small" state="black" :effects="false" />
		</Button>
	</div>
</template>
<script>
import { defineComponent } from "vue";
import html2canvas from "html2canvas";
import Button from "./../Button/Button";
import Icon from "./../Icon/Icon";

export default defineComponent({
	name: "Screenshot",
	components: {
		Button,
		Icon
	},
	props: {
		/**
		 * Placeholder to display inside box
		 */
		placeholder: {
			type: String,
			default: "Capture screenshot"
		},

		/**
		 * Placeholder to display while cpturing screenshot
		 */
		inProgressPlaceholder: {
			type: String,
			default: "Capturing screenshot..."
		},
		/**
		 * tabinder for keyboard operations
		 */
		tabindex: {
			type: Number,
			default: -1
		},
		/**
		 * html element query selector for screenshot
		 */
		querySelector: {
			type: String,
			default: "div.flow-layout"
		},
		/**
		 * html2cancas extra options
		 */
		options: {
			type: Object,
			// eslint-disable-next-line @typescript-eslint/no-empty-function
			default: () => {}
		}
	},
	data() {
		return {
			src: null,
			/**
			 *  -1 for empty
			 *  0  for inprogress
			 * 	1  for done or success
			 */
			state: -1
		};
	},
	computed: {
		/**
		 * Compute status
		 */
		status: {
			get() {
				if (this.state === -1) {
					return this.placeholder;
				}
				if (this.state === 0) {
					return this.inProgressPlaceholder;
				}
				return null;
			}
		}
	},
	methods: {
		/**
		 * handle Click event
		 */
		handleClick(e) {
			/**
			 * Click event
			 *
			 * @event click
			 */
			this.$emit("click", e);

			if (this.state !== 1) {
				this.state = 0;
				setTimeout(() => {
					this.capture();
				}, 0);
			}
		},
		/**
		 * Capture screenshot
		 */
		capture() {
			/**
			 * to support svg in rendered image
			 */
			const svgElements = document.body.querySelectorAll("svg");
			svgElements.forEach(function (item) {
				item.setAttribute("width", item.getBoundingClientRect().width);
				item.setAttribute("height", item.getBoundingClientRect().height);
				item.style.width = null;
				item.style.height = null;
			});
			/**
			 * capturing using html2canvas
			 */
			html2canvas(document.querySelector(this.querySelector), {
				// foreignObjectRendering: true,
				useCORS: true,
				logging: false,
				allowTaint: true,
				ignoreElements: element => {
					return (
						element.classList.contains("sideout-container") ||
						element.classList.contains("slideout-blackout") ||
						element.classList.contains("flow-popover-content") ||
						element.classList.contains("flow-popover-overlay")
					);
				},
				...this.options
			}).then(canvas => {
				this.src = canvas.toDataURL("image/png");
				this.state = 1;

				/**
				 * success event : emits image source
				 *
				 * @event dataUrl
				 */
				this.$emit("dataUrl", this.src);

				canvas.toBlob(blob => {
					/**
					 * success event : emits blob object of image
					 *
					 * @event blob
					 */
					this.$emit("blob", blob);
				});
			});
		}
	}
});
</script>
<style lang="scss">
div.flow-screenshot {
	height: 76px;
	display: flex;
	flex: 1 0 auto;
	border: 2px dashed var(--gray-300);
	background-color: var(--gray-400);

	justify-content: center;
	align-items: center;
	cursor: pointer;
	flex-direction: column;
	position: relative;

	border-radius: 4px;
	outline: none;
	> * + * {
		margin-top: 4px;
	}

	button.button-base[type="default"] {
		background-color: var(--dashboard-icon-light);
	}
	// canvas {
	// 	position: absolute;
	// 	top: 0px;
	// 	left: 0px;
	// 	right: 0px;
	// 	bottom: 0px;
	// }

	// div.flow-screenshot-wrapper {
	// 	width: 100%;
	// 	height: 100%;
	// }
	&[done] {
		height: auto;
		border: 1px solid var(--slideout-element-dark);
		// overflow: hidden;
	}
	img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.remove-screenshot {
		position: absolute;
		top: -12px;
		right: -10px;
	}

	// &:active {
	// 	filter: contrast(90%);
	// }

	// &:hover:not(:active) {
	// 	filter: contrast(95%);
	// }

	// &:focus {
	// 	border: 1px solid var(--slideout-primary);
	// 	outline: none;
	// }
}
</style>
